import React, { useContext } from 'react';
import styled from 'styled-components';

import FieldStyleSettings from './FieldStyleSettings';
import PositionSettings from './PositionSettings';
import MetadataSettings from './MetadataSettings';
import FieldSettingsHeaderTitle from './FieldSettingsHeaderTitle';
import CheckboxSettingsField from './CheckboxSettingsField';
import Button from '../../misc/Button';
import ConditionalLogicSettings from './ConditionalLogicSettings';
import SettingsTabs from './SettingsTabs';
import AccordionSettings from './AccordionSettings';
import SettingsLabel from './SettingsLabel';
import { StyledFieldWrapper, StyledButtonsWrapper, DividerLine } from './SettingsCommonElements';

import ThemeIcons from '../../../theme/Icons';
import ThemeContext from '../../../theme/ThemeContext';

const StyledWrapper = styled.div`
  padding: 12px 0px;
  display: flex;
  flex-direction: column;
`;

const FieldSettingsRichTextField = ({

  //Logic properties
  fileId,
  sortedPages,
  fields,
  logic,

  view,
  fieldId,
  fieldIdentifier,
  fieldPositionId,

  x,
  y,
  width,
  height,
  metadata,
  config,
  hidden,

  backgroundColor,
  borderColor,
  borderRadius,
  borderWidth,
  zIndex,

  //Action handlers
  onChange,
  onDelete,

}) => {

  const theme = useContext(ThemeContext);

  const stylesNode = (
    <AccordionSettings
      isOpen
      title="Field"
      height={320}
    >
      <FieldStyleSettings
        id={`${fieldId}-field`}
        {...{

          borderColorLabel: 'Border Color',
          borderColor,
          onBorderColorChange: (value) => onChange(fieldId, fieldIdentifier, fieldPositionId, { borderColor: value }),

          borderRadiusLabel: 'Border Radius',
          borderRadius,
          onBorderRadiusChange: (value) => onChange(fieldId, fieldIdentifier, fieldPositionId, { borderRadius: value }),

          borderWidthLabel: 'Border Width',
          borderWidth,
          onBorderWidthChange: (value) => onChange(fieldId, fieldIdentifier, fieldPositionId, { borderWidth: value }),

          backgroundColorLabel: 'Background',
          backgroundColor,
          onBackgroundColorChange: (value) => onChange(fieldId, fieldIdentifier, fieldPositionId, { backgroundColor: value }),

          zIndexLabel: 'Layer',
          zIndex,
          onZIndexChange: (value) => (value ? onChange(fieldId, fieldIdentifier, fieldPositionId, { zIndex: value }) : ''),

        }}
      />
      <PositionSettings
        {...{
          view,
          x,
          y,
          width,
          height,
          onChange: (field, value) => onChange(fieldId, fieldIdentifier, fieldPositionId, { [field]: value })
        }}
      />
    </AccordionSettings>
  );

  const settingsNode = (
    <>
      <SettingsLabel>Field</SettingsLabel>
      <DividerLine style={{ marginBottom: 14 }} />
      <StyledFieldWrapper>
        <CheckboxSettingsField
          icon={ThemeIcons.settings.hide}
          iconColor={hidden ? theme.warningColor : theme.borderColor}
          id="hidden"
          label="Hidden"
          selected={hidden}
          onChange={(selected) => onChange(fieldId, fieldIdentifier, fieldPositionId, { hidden: selected },)}
        />
      </StyledFieldWrapper>
      {fields.length < 2 ? null : (
        <>
          <DividerLine />
          <StyledFieldWrapper>
            <ConditionalLogicSettings
              fileId={fileId}
              targetLabel=" field"
              targetFieldId={fieldId}
              sortedPages={sortedPages}
              fields={fields}
              logic={logic}
              onSubmit={(nextLogic) => onChange(fieldId, fieldIdentifier, fieldPositionId, { logic: nextLogic })}
            />
          </StyledFieldWrapper>
        </>
      )}
      {!config?.metadata ? null : (
        <>
          <DividerLine />
          <MetadataSettings
            metadata={metadata}
            metadataOptions={config?.metadata}
            onChange={(changes) => {
              const nextMetadata = metadata ? { ...metadata, ...changes } : { ...changes };
              onChange(fieldId, fieldIdentifier, fieldPositionId, { metadata: nextMetadata });
            }}
          />
        </>
      )}
      <DividerLine style={{ marginBottom: 14 }} />
      <StyledButtonsWrapper>
        <Button
          danger
          icon={ThemeIcons.settings.delete}
          text="Delete"
          onClick={() => onDelete(fieldId, fieldIdentifier, fieldPositionId)}
        />
      </StyledButtonsWrapper>

    </>
  );

  return (
    <StyledWrapper data-testid="form-settings">
      <FieldSettingsHeaderTitle
        title="Settings"
        icon={ThemeIcons.fields.richText}
      />
      <SettingsTabs
        settings={settingsNode}
        styles={stylesNode}
      />
    </StyledWrapper>
  );

};

export default FieldSettingsRichTextField;
